<template>
  <div class="h-full">
    <Transition
      name="fade-medium"
      mode="out-in"
    >
      <div
        v-if="$route.name !== 'AuthSignUp'"
        class="h-full relative"
      >
        <div class="absolute w-full h-full bg-primary-dark opacity-75"></div>
        <div class="illustration-image"></div>
      </div>
      <ElCarousel
        v-else
        key="carousel"
        :interval="8000"
        height="100%"
        arrow="never"
        class="h-full"
      >
        <ElCarouselItem
          v-for="(item, index) in carouselSlides"
          :key="index"
        >
          <div class="illustration-dimmer absolute w-full h-full"></div>
          <div
            class="illustration-image"
            :style="{ 'background-image': `url(${item.illustrationSrc})` }"
          ></div>
          <div class="absolute bottom-0 text-white text-lg leading-normal p-40">
            <FontAwesomeIcon
              :icon="['fal', 'quote-left']"
              size="2x"
              class="mb-10"
            />
            <p class="italic whitespace-pre-wrap mb-40">{{ item.feedback }}</p>
            <p class="mb-20">
              {{ item.name }}
            </p>
            <img
              :src="item.logoSrc"
              :alt="item.logoAlt"
              class="max-h-75"
            >
          </div>
        </ElCarouselItem>
      </ElCarousel>
    </Transition>
  </div>
</template>

<script>
export default {
  data: () => ({
    carouselSlides: [{
      feedback: `I used the app for 3 store opening events in Switzerland. The app is very easy to use and reliable.\n
        ClickOn even provided us 2 Nexus 9s. Great product & great service !`,
      name: 'Fanny Tribala',
      illustrationSrc: '/images/auth/event-bulgari/illustration.jpg',
      logoSrc: '/images/auth/event-bulgari/brand-logo.png',
      logoAlt: 'Bulgari logo',
    }, {
      feedback: `We do use the App for all Events our VIP events, it is very easy to use for our models and hostesses who are in charge of the entry control and guest list.\n
        There is no further explanation needed, very easy to use.`,
      name: 'Martina Marthaler',
      illustrationSrc: '/images/auth/event-huber-promotion/illustration.jpg',
      logoSrc: '/images/auth/event-huber-promotion/brand-logo.png',
      logoAlt: 'Huber Event Promotion logo',
    }, {
      feedback: `We used it for a conference of 350 guests and our registration process has never been so quick.\n
        It's really easy to find the guests by first or last name or a company.
        The tech support replies very quickly and adequately. Highly recommend!`,
      name: 'Kristina Hristova',
      illustrationSrc: '/images/auth/event-south-eath-european-testing-board/illustration.jpg',
      logoSrc: '/images/auth/event-south-eath-european-testing-board/brand-logo.png',
      logoAlt: 'South East European Testing Board',
    }],
  }),
};
</script>

<style scoped>
.illustration-image {
  @apply h-full bg-cover bg-no-repeat;

  /* Sign-in: Bulgari store opening, two hostesses with tablets (Drive: Guestlist/fotos-from-suryia/1409224_bulgari,
     foto-31.jpg). The aside is half the screen from tablet width up, so on narrow asides only the middle of the photo
     shows; 64% centres the right hostess (facing the camera, tablet raised) at every aside width. */
  background-image: url('/images/auth/signin-illustration-hostesses-w1200.jpg');
  background-position: 64% center;
}

.illustration-dimmer {
  background-image: linear-gradient(0deg, rgba(0, 0, 0, 0.85) 0%, rgba(0, 0, 0, 0.75) 340px,
    rgba(0, 0, 0, 0.6) 380px, rgba(0, 0, 0, 0.1) 100%);
}

@screen laptop-l {
  .illustration-image {
    background-image: url('/images/auth/signin-illustration-hostesses.jpg');
  }
}
</style>
